(function () {
  var FORM_SELECTOR = 'form.horizontal-product__form.js-product-form[data-product-id]';

  function getFormState(form) {
    var variantsNode = form.querySelector('[data-product-variants]');
    var variantIdInput = form.querySelector('[data-variant-id-input]');
    var submitButton = form.querySelector('[data-add-to-cart]');
    var optionSelectors = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));

    if (!variantIdInput || !submitButton) return null;

    var variants = [];
    if (variantsNode) {
      try {
        variants = JSON.parse(variantsNode.textContent || '[]');
      } catch (e) {
        variants = [];
      }
    }

    return {
      variantIdInput: variantIdInput,
      submitButton: submitButton,
      optionSelectors: optionSelectors,
      variants: variants,
      addToCartText: ((form.querySelector('[data-add-to-cart-text]') || {}).textContent || 'Add to cart'),
      soldOutText: ((form.querySelector('[data-sold-out-text]') || {}).textContent || 'Sold out'),
      addToCartUrl: (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js'
    };
  }

  function updateCartUi(data) {
    var sectionsToUpdate = ['page-header', 'cart-drawer']
      .map(function (selector) { return document.querySelector(selector); })
      .filter(function (el) { return !!el; });

    if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
      sectionsToUpdate.forEach(function (sectionEl) {
        if (typeof sectionEl.updateFromCartChange === 'function') {
          sectionEl.updateFromCartChange(data.sections[sectionEl.dataset.sectionId]);
        }
      });
    } else {
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    }
  }

  function bindVariantSelectors(form, state) {
    if (!state.optionSelectors.length || !state.variants.length) return;

    var updateVariant = function () {
      var selectedOptions = [];

      state.optionSelectors.forEach(function (selector) {
        var optionIndex = Number(selector.getAttribute('data-option-index'));
        selectedOptions[optionIndex] = selector.value;
      });

      var matchedVariant = state.variants.find(function (variant) {
        return selectedOptions.every(function (selectedValue, optionIndex) {
          return !selectedValue || variant.options[optionIndex] === selectedValue;
        });
      });

      if (!matchedVariant) return;

      state.variantIdInput.value = matchedVariant.id;
      state.submitButton.disabled = !matchedVariant.available;
      state.submitButton.textContent = matchedVariant.available ? state.addToCartText : state.soldOutText;
    };

    state.optionSelectors.forEach(function (selector) {
      selector.addEventListener('change', updateVariant);
    });

    updateVariant();
  }

  async function handleDelegatedSubmit(event) {
    var form = event.target.closest(FORM_SELECTOR);
    if (!form) return;

    event.preventDefault();

    var state = getFormState(form);
    if (!state) return;
    if (state.submitButton.disabled || state.submitButton.getAttribute('aria-disabled') === 'true') return;

    state.submitButton.setAttribute('aria-disabled', 'true');
    state.submitButton.classList.add('is-loading');

    try {
      var formData = new FormData(form);
      var sectionIds = ['page-header', 'cart-drawer']
        .map(function (selector) { return document.querySelector(selector); })
        .filter(function (el) { return !!el; })
        .map(function (sectionEl) { return sectionEl.dataset.sectionId; });

      if (sectionIds.length) {
        formData.append('sections_url', window.location.pathname);
        formData.append('sections', sectionIds.join(','));
      }

      var response = await fetch(state.addToCartUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      var data = await response.json();
      if (!response.ok || data.status) {
        throw new Error((data && (data.description || data.message)) || 'Failed to add to cart');
      }

      updateCartUi(data);

      document.dispatchEvent(new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: {
          variantId: data.variant_id
        }
      }));

      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
        bubbles: true,
        detail: {
          opener: state.submitButton
        }
      }));

      state.submitButton.classList.add('is-success');
    } catch (error) {
      document.dispatchEvent(new CustomEvent('on:cart:error', {
        bubbles: true,
        detail: {
          error: (error && error.message) || 'Failed to add to cart'
        }
      }));
    } finally {
      state.submitButton.removeAttribute('aria-disabled');
      setTimeout(function () {
        state.submitButton.classList.remove('is-loading');
        state.submitButton.classList.remove('is-success');
      }, 800);
    }
  }

  function initForm(form) {
    if (form.dataset.horizontalProductInit === 'true') return;

    var state = getFormState(form);
    if (!state) return;

    bindVariantSelectors(form, state);
    form.dataset.horizontalProductInit = 'true';
  }

  function initAll(scope) {
    var root = scope || document;
    var forms = root.querySelectorAll(FORM_SELECTOR);
    forms.forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('submit', function (event) {
    handleDelegatedSubmit(event);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

